<script setup lang="ts">
import { computed, ref } from "vue";
import { bemBuilder, toMoney } from "@chatfood/core-utils";
import {
  AtomText,
  AtomIcon,
  AtomSkeletonLoader,
} from "@chatfood/design-system";
import { useCustomerStore } from "~/stores/customer";
import { useBusinessStore } from "#imports";

const css = bemBuilder("loyalty-native-balance");
const businessStore = useBusinessStore();

const customerStore = useCustomerStore();

const walletBalance = computed(() => {
  return customerStore.loyalty.wallet.cash.balance;
});

const loading = ref(true);

const syncCustomerLoyaltyProfile = async () => {
  loading.value = true;
  try {
    await customerStore.syncLoyalty(
      businessStore.id,
      businessStore.salesChannel,
    );
  } finally {
    loading.value = false;
  }
};

syncCustomerLoyaltyProfile();
</script>

<template>
  <div :class="css()">
    <AtomSkeletonLoader v-if="loading" type="rounded" :size="145" :lines="1" />
    <div v-else :class="css('content')" data-test="content">
      <AtomIcon name="crown" size="x-large" color="color-on-primary" />
      <AtomText type="subtitle" color="color-on-primary">
        {{ toMoney(walletBalance.value, walletBalance.currency) }}
      </AtomText>
    </div>
  </div>
</template>

<style scoped lang="scss">
.loyalty-native-balance {
  &__content {
    width: 145px;
    height: 145px;
    display: flex;
    border-radius: 50%;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background-color: var(--color-primary);
  }
}
</style>
